const GooglePlayStoreIcon = (props:{height?: number, width?: number}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 800}
    height={props.height ? props.height : 800}
    preserveAspectRatio="xMidYMid"
    viewBox="-9 0 274 274"
    {...props}
  >
    <path
      fill="#FFD900"
      d="M188.813 178.875c32.46-17.823 57.067-31.404 59.188-32.46 6.785-3.608 13.792-13.158 0-20.576-4.453-2.333-28.428-15.491-59.188-32.46l-42.642 43.065 42.642 42.43Z"
    />
    <path
      fill="#F43249"
      d="M146.171 136.444 10.394 273.287c3.187.422 6.785-.423 11.027-2.755 8.906-4.875 103.318-56.434 167.392-91.647l-42.642-42.441Z"
    />
    <path
      fill="#00EE76"
      d="m146.171 136.444 42.642-42.853S30.971 7.45 21.421 2.365C17.823.234 13.791-.399 10.183.234l135.988 136.21Z"
    />
    <path
      fill="#00D3FF"
      d="M146.171 136.444 10.183.234C4.664 1.51 0 6.386 0 16.358v240.805c0 9.127 3.609 15.701 10.394 16.335l135.777-137.054Z"
    />
  </svg>
)
export default GooglePlayStoreIcon
